import { postRequest } from "./postRequest";

export type ApiResponse<T> = {
  success: boolean;
  errorCode?: string | null;
  errorDetail?: string | null;
  data?: T;
};

// ---- CREATE
export type MSiparisKalemAdd = {
  urunId: number;
  varyantId: number;
  urunAdi: string;
  secenekOzeti?: string | null;
  adet: number;
  birimFiyatNet: number;
  vergiOraniYuzde: number;
  satirIndirimNet?: number | null;
};

export type MSiparisOlusturRequest = {
  musteriId?: number | null;
  paraBirimiKodu?: string;
  faturaAdresiJson?: string | null;
  teslimatAdresiJson?: string | null;
  notlar?: string | null;
  kargoUcretiNet?: number | null;
  items: MSiparisKalemAdd[];
};

export type MSiparisOlusturResponse = {
  siparisId: number;
  siparisNo: string;
  araToplamNet: number;
  indirimToplamNet: number;
  kargoUcretiNet: number;
  vergiToplam: number;
};

export const orderApi = {
  create: (payload: MSiparisOlusturRequest) =>
    postRequest<MSiparisOlusturRequest, ApiResponse<MSiparisOlusturResponse>>(
      "/musteri/siparis/olustur",
      payload
    ),

  // ---- LIST
  list: (payload: {
    musteriId: number;
    page?: number;
    pageSize?: number;
    durumKodu?: number;
    odemeDurumu?: number;
    sort?: "yeni" | "eski";
  }) =>
    postRequest<typeof payload, ApiResponse<{
      items: Array<{
        siparisId: number;
        siparisNo: string;
        durumKodu: number;
        paraBirimiKodu: string;
        araToplamNet: number;
        indirimToplamNet: number;
        kargoUcretiNet: number;
        vergiToplam: number;
        genelToplamBrut: number;
        odemeDurumu: number;
        siparisTarihi: string;
        guncellemeTarihi?: string | null;
      }>;
      total: number;
      page: number;
      pageSize: number;
    }>>("/musteri/siparis/listele", payload),

  // ---- DETAIL
  detail: (payload: { siparisId: number; musteriId: number }) =>
    postRequest<typeof payload, ApiResponse<{
      header: {
        siparisId: number;
        siparisNo: string;
        paraBirimiKodu: string;
        genelToplamBrut: number;
        araToplamNet: number;
        indirimToplamNet: number;
        kargoUcretiNet: number;
        vergiToplam: number;
        odemeDurumu: number;
        siparisTarihi: string;
        faturaAdresiJson?: string | null;
        teslimatAdresiJson?: string | null;
      };
      items: Array<{
        siparisKalemId: number;
        urunId: number;
        varyantId: number;
        urunAdi: string;
        secenekOzeti?: string | null;
        adet: number;
        birimFiyatNet: number;
        vergiOraniYuzde: number;
        satirIndirimNet: number;
        satirVergi: number;
        satirToplamBrut: number;
      }>;
      payments: Array<{
        odemeIslemId: number;
        odemeSaglayici?: string | null;
        tutarBrut: number;
        paraBirimiKodu: string;
        islemDurumu: number;
        olusturmaTarihi: string;
      }>;
      shipments: Array<{
        sevkiyatId: number;
        kargoSirketAdi?: string | null;
        takipNo?: string | null;
        durumKodu: number;
        notlar?: string | null;
        olusturmaTarihi: string;
      }>;
    }>>("/musteri/siparis/detay", payload),
};
